import { render, staticRenderFns } from "./embedDetail.vue?vue&type=template&id=ffe76852&"
import script from "./embedDetail.vue?vue&type=script&lang=js&"
export * from "./embedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports